module.exports = __webpack_public_path__ + "img/icon-users-gray.d2c42a4a.svg";